import {
    all,
    takeEvery,
    fork,
    put,
    select,
    call,
    takeLatest,
    delay,
} from 'redux-saga/effects'
import actions from './actions'
import {
    getListOrgAPI,
    getOrgByOidAPI,
    updateOrgByOidAPI,
    deleteOrgByOidAPI,
    addNewOrgAPI,
    getListUser,
    searchUserAPI,
    getListOrgQueryById,
    uploadAvatar,
} from '../../services/apis/OrganizationsAPIService'
import {
    getListRoles,
    getListActionByRoleId,
} from '../../services/apis/RoleAPIServices'

import { message } from 'antd'

function* saga_LoadListOrganization(action) {
    try {
        //Todo: request API loadData
        //request loadListUer

        const { loadType } = action.payload
        const response = yield call(getListOrgAPI, loadType)
        console.log('list org load', response)
        if (response.error.code === 200) {
            //const listAllUser = yield getListUsers(0, 0, 1)
            let organizations = response.data
            yield put(actions.action.loadListOrganizationSuccess(organizations))
        }
    } catch (ex) {
        console.error('Load list organization error : ', ex.message)
    }
}

function* saga_GetListBoss(action) {
    try {
        let { array } = action.payload
        if (array.length === 0) {
            yield put(actions.action.getListBossSuccess([]))
            return
        }
        const response = yield call(getListUser, array)

        if (response.error.code === 200) {
            //const listAllUser = yield getListUsers(0, 0, 1)
            let users = response.data
            yield put(actions.action.getListBossSuccess(users))
        }
    } catch (ex) {
        yield put(actions.action.getListUserFailed(ex))
        console.error('Load list organization error : ', ex.message)
    }
}

function* saga_GetListDeputy(action) {
    try {
        let { array } = action.payload
        if (array.length === 0) {
            yield put(actions.action.getListDeputySuccess([]))
            return
        }
        const response = yield call(getListUser, array)
        if (response.error.code === 200) {
            //const listAllUser = yield getListUsers(0, 0, 1)
            let users = response.data
            yield put(actions.action.getListDeputySuccess(users))
            return
        }
    } catch (ex) {
        yield put(actions.action.getListUserFailed(ex))
        console.error('Load list organization error : ', ex.message)
    }
}

function* saga_GetListMember(action) {
    try {
        let { array } = action.payload
        if (array.length === 0) {
            yield put(actions.action.getListMemberSuccess([]))
            return
        }
        const response = yield call(getListUser, array)
        if (response.error.code === 200) {
            //const listAllUser = yield getListUsers(0, 0, 1)
            let users = response.data
            yield put(actions.action.getListMemberSuccess(users))
            return
        }
    } catch (ex) {
        yield put(actions.action.getLisMemberFailed(ex))
        console.error('Load list organization error : ', ex.message)
    }
}
function* saga_AddOrganization(action) {
    try {
        let { organization } = action.payload
        console.log('saga_AddOrganization organization: ', organization)

        const response = yield call(addNewOrgAPI, organization)

        console.log('saga_AddOrganization organization: ', response)

        if (response.error.code === 200) {
            const loadType = yield select(state => state.organization.loadType)
            console.log('loadType: ', loadType)
            yield put(actions.action.loadListOrganization(loadType))
            //yield put(actions.action.addOrganizationSuccess(organization));

            message.success('Thêm Đơn Vị Thành Công')
        } else {
            yield put(actions.action.addOrganizationFailed(response))
            message.error('Thêm Đơn Vị Không Thành Công')
            console.error(
                'add organization call API error : ',
                response.error.message
            )
        }
    } catch (ex) {
        console.error('Create organization error : ', ex.message)
    }
}

function* saga_UpdateOrganization(action) {
    try {
        let { oid, organization } = action.payload
        const response = yield call(updateOrgByOidAPI, oid, organization)
        //yield put(actions.action.updateOrganizationSuccess(organization))
        if (response.error.code === 200) {
            const loadType = yield select(state => state.organization.loadType)
            yield put(actions.action.loadListOrganization(loadType))
            message.success('Cập Nhật Đơn Vị Thành Công')
            //yield put(actions.action.updateOrganizationSuccess(oid,organization))
        } else {
            message.error('Lỗi Khi Cập Nhật Đơn Vị')
            console.log(
                'Update organization call API error : ',
                response.error.message
            )
        }
    } catch (ex) {
        console.error('Update organization error : ', ex.message)
    }
}

function* saga_RemoveOrganization(action) {
    try {
        const { oid } = action.payload
        const response = yield call(deleteOrgByOidAPI, oid)
        console.log('DELETE: ', oid, response)
        if (response.error.code === 200) {
            // const loadType = yield select(state => state.organization.loadType)
            // yield put(actions.action.loadListOrganization(loadType))
            yield put(actions.action.removeOrganizationSucess(oid))
            message.success('Xóa Đơn Vị Thành Công')
        } else {
            yield put(actions.action.removeOrganizationSucess(oid))
            message.error('Xóa Đơn Vị Không Thành Công')
            console.log(
                'Update organization call API error : ',
                response.error.message
            )
        }
    } catch (ex) {
        console.error('Remove organization error : ', ex.message)
    }
}

function* saga_GetCurrentOrganization(action) {
    try {
        const { oid } = action.payload
        const response = yield call(getOrgByOidAPI(oid))

        if (response.error.code === 200) {
            const info = response.data
            yield put(actions.action.updateCurrentOrganization(info))
        } else {
            console.log(
                'Get current organization call API error : ',
                response.error.message
            )
        }
    } catch (ex) {
        console.error('Get current organization error : ', ex.message)
    }
}

function* saga_SearchMember(action) {
    try {
        const { keyword, typeUser } = action.payload
        yield delay(100)
        const response = yield searchUserAPI(1, 10, keyword)

        console.log('response: search ', response)
        if (response.error.code === 200) {
            const data = response.data

            switch (typeUser) {
                case 1:
                    yield put(actions.action.getListBossSuccess(data))
                    break
                case 2:
                    yield put(actions.action.getListDeputySuccess(data))
                    break
                case 3:
                    yield put(actions.action.getListMemberSuccess(data))
                    break
                default:
                    break
            }
            yield put(actions.action.searchMemberSuccess(data))
        } else {
            console.log(
                'Get current organization call API error : ',
                response.error.message
            )
        }
    } catch (ex) {
        console.error('saga_SearchMember : ', ex.message)
    }
}

function* saga_getListOrgQueryById(action) {
    try {
        const { lst } = action.payload
        const response = yield call(getListOrgQueryById, lst)
        if (response.error.code === 200) {
            yield put(actions.action.getListOrgQueryByIdDone(response.data))
        } else {
            console.error('response: saga_getListOrgQueryById ', response)
        }
    } catch (ex) {
        console.error('get List Org Query error : ', ex.message)
    }
}
function* saga_getOrgById(action) {
    try {
        const { lst } = action.payload
        const response = yield call(getListOrgQueryById, lst)
        console.log('get org by id', response)
        if (response.error.code === 200) {
            yield put(actions.action.getOrgByIdDone(response.data[0]))
        } else {
            yield put(actions.action.getOrgByIdDone({}))
        }
    } catch (ex) {
        console.error('get Org by id error : ', ex.message)
    }
}
function* saga_createAvatarOrganization(action) {
    let { data } = action.payload
    const responseUploadAvatar = yield uploadAvatar(data)
    const avatarUrl = responseUploadAvatar.uploaded_files[0]

    let currentOrganization = yield select(
        state => state.organization.currentOrganization
    )
    let { ext_data } = currentOrganization
    ext_data.avatarOrgani = avatarUrl
    yield put(actions.action.updateCurrentOrganization(ext_data))
}

function* saga_SaveOrganiCurrent() {
    try {
        let currentOrganization = yield select(
            state => state.organization.currentOrganization
        )
        if (currentOrganization.oid === -1) {
            yield put(actions.action.addOrganization(currentOrganization))
        } else {
            yield put(
                actions.action.updateOrganization(
                    currentOrganization.oid,
                    currentOrganization
                )
            )
        }
    } catch (ex) {
        console.error('Save current organi error : ', ex.message)
    }
}

function* saga_GetListUserInOrgani(action) {
    try {
        let { array } = action.payload
        const response = yield call(getListUser, array)
        if (response.error.code === 200) {
            //const listAllUser = yield getListUsers(0, 0, 1)
            let users = response.data
            yield put(actions.action.getListUserInOrganiSuccess(users))
        }
    } catch (ex) {
        console.error('Load list organization error : ', ex.message)
    }
}

function* saga_GetActionsInRole(action) {
    try {
        const { idRole } = action.payload
        console.log('idRole ', idRole)

        const response = yield call(getListActionByRoleId, idRole)
        console.log('getListActionByRoleId ', response)

        if (idRole === 0) {
            let role = {
                createOrgani: true,
                editOrgani: true,
                viewOrgani: true,
                deleteOrgani: true,
            }
            console.log('ROLE: QTHT: ', role)
            yield put(actions.action.updateRoleOfUserInOrgani(role))
            return
        }

        if (response.error.code === 200) {
            let role = {
                createOrgani: false,
                editOrgani: false,
                viewOrgani: false,
                deleteOrgani: false,
            }
            let listAction = response.data

            const createOrgani = listAction.findIndex(
                item => item.action === 'ORGANIZATION_CREATE'
            )
            const editOrgani = listAction.findIndex(
                item => item.action === 'ORGANIZATION_EDIT'
            )
            const viewOrgani = listAction.findIndex(
                item => item.action === 'ORGANIZATION_VIEW'
            )
            const deleteOrgani = listAction.findIndex(
                item => item.action === 'ORGANIZATION_DELETE'
            )

            if (createOrgani > 0) {
                console.log('ORGANIZATION_CREATE')
                role.createOrgani = true
            }
            if (editOrgani > 0) {
                console.log('ORGANIZATION_EDIT')
                role.editOrgani = true
            }
            if (viewOrgani > 0) {
                console.log('ORGANIZATION_VIEW')
                role.viewOrgani = true
            }
            if (deleteOrgani > 0) {
                console.log('ORGANIZATION_DELETE')
                role.deleteOrgani = true
            }

            //console.log("ROLE: ", role)

            yield put(actions.action.updateRoleOfUserInOrgani(role))
        } else {
            console.log(
                'Get List User Roles Call API Error : ',
                response.error.message
            )
        }
    } catch (ex) {
        console.log(' error : ', ex.message)
    }
}

function* listen() {
    yield takeEvery(
        actions.type.LOAD_LIST_ORGANIZATIONS,
        saga_LoadListOrganization
    )
    yield takeEvery(actions.type.UPDATE_ORGANIZATION, saga_UpdateOrganization)
    yield takeEvery(actions.type.SAVE_ORGANI_CURRENT, saga_SaveOrganiCurrent)

    yield takeEvery(actions.type.REMOVE_ORGANIZATION, saga_RemoveOrganization)
    yield takeEvery(actions.type.ADD_ORGANIZATIONS, saga_AddOrganization)
    yield takeEvery(
        actions.type.GET_CURENT_ORGANIZATION,
        saga_GetCurrentOrganization
    )
    yield takeEvery(actions.type.GET_BOSS, saga_GetListBoss)
    yield takeEvery(actions.type.GET_LIST_DEPUTY, saga_GetListDeputy)
    yield takeEvery(actions.type.GET_LIST_MEMBER, saga_GetListMember)
    yield takeEvery(
        actions.type.GET_LIST_USER_IN_ORGANI,
        saga_GetListUserInOrgani
    )

    yield takeEvery(
        actions.type.CREATE_AVATAR_ORGANIZATION,
        saga_createAvatarOrganization
    )
    yield takeLatest(actions.type.SEARCH_MEMBER, saga_SearchMember)
    yield takeLatest(
        actions.type.GET_LIST_ORG_QUERY_BY_ID,
        saga_getListOrgQueryById
    )
    yield takeEvery(actions.type.GET_LIST_ACTION_BY_ID, saga_GetActionsInRole)
    yield takeEvery(actions.type.GET_ORG_BY_ID, saga_getOrgById)
}

export default function* organizationSaga() {
    yield all([fork(listen)])
}
